class SessionStorage<T> {
  readonly key: string;

  constructor(key: string) {
    this.key = key;
  }

  exists(): boolean {
    return Object.keys(sessionStorage).includes(this.key);
  }

  get(): T | undefined {
    return this.exists()
      ? (JSON.parse(sessionStorage.getItem(this.key) as string) as T)
      : undefined;
  }

  set(instance: T): void {
    sessionStorage.setItem(this.key, JSON.stringify(instance));
  }

  clear(): void {
    sessionStorage.removeItem(this.key);
  }
}
export default SessionStorage;
